import React from 'react';
import '../Medispace.css';
import DemoHi from '../assets/images/demo_hi.png';
import Logo from '../assets/images/logo_hocoia.svg';
import LogoMspDomus from '../assets/images/logo_msp_domus.png';
import QRCode from "react-qr-code";

class MspDomus extends React.Component {

    constructor(props) {
        super(props);
        const actualUrl = new URL(window.location.href)
        const searchParams = new URLSearchParams(actualUrl.search)
        this.state = {
            sessions: [],
            displayRoomData: false,
            hocoSettings: 'none',
            mailSent: false
        }
        if (searchParams.get("hocosettings")) {
            this.state.hocoSettings = searchParams.get("hocosettings");
        }
        this.askNewRoom = this.askNewRoom.bind(this);
        this.deleteRoom = this.deleteRoom.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteAndCreateRoom = this.deleteAndCreateRoom.bind(this);
    }

    async createSession() {
        let res = await window.sdk.session().createOneToOne();
        return res
    }

    async displayRoomData() {
        this.setState({
            displayRoomData: true 
        });
        this.setState({ 
            mailSent : false 
        });
        this.state.mailSent = false;
    }

    async askNewRoom(event) {
        event.preventDefault();
        this.state.sessions = await this.createSession();
        await this.displayRoomData();
    }

    async deleteRoom(event) {
        event.preventDefault();
        let res = await window.sdk.session().destroyOneToOne(this.state.sessions[0].onetoone.token);
        this.setState({ sessions : [] });
        this.setState({ displayRoomData : false });
        this.state.displayRoomData = false;
        this.state.sessions = [];
    }

    async deleteAndCreateRoom(event) {
        event.preventDefault();
        await window.sdk.session().destroyOneToOne(this.state.sessions[0].onetoone.token);
        await this.askNewRoom(event);
    }

    getSessionUrl(session) { 
        return `/onetoone/${session.onetoone.token}/${session.token}`
    };


    async launchSession(sessionToLaunch) {
        window.page = window.open(this.getSessionUrl(sessionToLaunch)+'?hocoSettings='+this.state.hocoSettings,"_blank");
    }

    getExternSession() {
        return this.state.sessions.find(s => s.name==='extern');
    }

    getDoctorSession() {
        return this.state.sessions.find(s => s.name==='medecin');
    }

    async handleSubmit(event) {
        event.preventDefault();
        let doctorSession = this.getDoctorSession();
        this.state.mailSent = await window.sdk.session().sendThirdPartyLink(event.target.email.value, doctorSession.onetoone.token, doctorSession.token, this.state.hocoSettings);
        this.setState({ mailSent : this.state.mailSent });
    }
    

    render(){
        return(
            <React.Fragment>

                <div className='medispace-container'>
                    <div className='medispace-panel medispace-left-panel'>
                        <div className='medispace-logos-line'>
                            <div>
                                <img className='medispace-hocoia-logo' src={Logo} alt='hocoia'/>
                            </div>
                            <div>
                                <img className='msp-domus-logo' src={LogoMspDomus} alt='Medispace'/>
                            </div>
                        </div>
                        <div style={{display: this.state.displayRoomData ? 'none' : 'block' }} className='medispace-empty-div'></div>
                        <h1 className='medispace-h1'>Bienvenue sur HocoVisio</h1>
                        <p className='medispace-p'>Un logiciel conçu pour vous permettre de réaliser une téléconsultation augmentée.</p>
                        <button 
                            style={{display: this.state.displayRoomData ? 'none' : 'block' }}
                            className='medispace-button' 
                            onClick={this.askNewRoom}>
                            Créer une nouvelle room
                        </button>
                        <div style={{display: this.state.displayRoomData ? 'block' : 'none' }}>
                            <button 
                                className='medispace-button' 
                                onClick={(e)=> {this.launchSession(this.state.sessions[0])}}>
                                Rejoindre la téléconsultation
                            </button>
                            <div className='medispace-insert medispace-insert-mail' >
                                <span className='medispace-span'>
                                    Transmettre un lien de connexion à un tiers agréé.
                                </span>
                                <form onSubmit={this.handleSubmit}>
                                    <div className='medispace-input-container'>
                                        <label className='medispace-label'>
                                            Email*
                                        </label>
                                        <br/>
                                        <input 
                                            className='medispace-input' type="email" name="email" 
                                            placeholder='Adresse e-mail du tiers'
                                        />
                                        <span 
                                            style={{display: this.state.mailSent ? 'block' : 'none' }}
                                            className='medispace-label'>
                                            Mail envoyé !
                                        </span>
                                    </div>
                                    <button className='medispace-button' type="submit">Envoyer</button>
                                </form>
                            </div>
                            <div className='medispace-insert medispace-insert-qrcode' >
                                <span className='medispace-span'>
                                    Si besoin, vous pouvez scaner le QRCode suivant pour connecter le dermatoscope déporté.
                                </span>
                                <br/><br/>
                                { this.getExternSession() && <QRCode
                                    size={124}
                                    value={`https://${window.location.hostname}${this.getSessionUrl(this.getExternSession())}`}
                                    viewBox={`0 0 128 128`}
                                ></QRCode>}
                            </div>
                            <div className='medispace-insert medispace-session-buttons'>
                                <button 
                                    className='medispace-button medispace-delete-session'
                                    onClick={this.deleteRoom}>
                                    Supprimer la room
                                </button>
                                <button 
                                    className='medispace-button'
                                    onClick={this.deleteAndCreateRoom}>
                                    Créer une nouvelle room
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='medispace-panel medispace-right-panel'>
                        <div className='medispace-center-img'>
                            <img className='medispace-img' src={DemoHi} alt='welcome'/>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}

export default MspDomus;
